import { createSlice } from '@reduxjs/toolkit';
import initialState from './newSessionFilterInitialState';
import {
  _setStudentId,
  _setStudentName,
  _setSubject,
  _setSubjectName,
  _setDate,
  _setOverrideLimits,
} from './newSessionFilterAction';

export const newSessionFilterSlice = createSlice({
  name: 'delta/newSessionFilter',
  initialState,
  reducers: {
    setStudentId: _setStudentId,
    setStudentName: _setStudentName,
    setSubject: _setSubject,
    setSubjectName: _setSubjectName,
    setDate: _setDate,
    setOverrideLimits: _setOverrideLimits,
    resetNewSessionFilter: () => initialState,
  },
});

export const {
  setStudentId,
  setStudentName,
  setSubject,
  setSubjectName,
  setDate,
  setOverrideLimits,
  resetNewSessionFilter,
} = newSessionFilterSlice.actions;

export default newSessionFilterSlice.reducer;
